import { put, select, takeEvery } from 'redux-saga/effects'

import { Game, Auth, Api, Firebase } from '../../Core'

import * as actions from './profile.actions'

import ProfileScreen from './ProfileScreen'
/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}

/** loadComponents **/
export function* loadComponents() {
  const components = {
    ProfileScreen,
  }
  yield put(Game.actions.registerComponents(components))
}

export function* getProfileBattles() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const groupData = yield select(Firebase.selectors.getGroupData)
  try {
    const response = yield Api.get(
      `/battles?groupId=${userInfo.licenseData.groupId}&session=${groupData.session}&session=${
        groupData.session - 1
      }&players=${userInfo.licenseId}`,
      {}
    )
    yield put(actions.setProfileBattles(response.docs))
    yield put(Game.actions.addScreen('profile_screen'))
  } catch (e) {
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

/**
 *  Calendar sagas entrypoint
 */
export function* sagas() {
  yield init()
  yield takeEvery(actions.GET_PROFILE_BATTLES, getProfileBattles)
}
